var exports = {
  "kL": "PiPOverlay.module__container___NEE1MD",
  "$I": "PiPOverlay.module__containerResizing___NEE1MD",
  "n_": "PiPOverlay.module__hoverOverlay___NEE1MD",
  "YQ": "PiPOverlay.module__containerInteractionActive___NEE1MD",
  "YL": "PiPOverlay.module__headerGradient___NEE1MD",
  "VW": "PiPOverlay.module__headerContent___NEE1MD",
  "LD": "PiPOverlay.module__headerLeft___NEE1MD",
  "q3": "PiPOverlay.module__returnToCallButton___NEE1MD",
  "fs": "PiPOverlay.module__returnToCallIcon___NEE1MD",
  "Qt": "PiPOverlay.module__returnToCallLabel___NEE1MD",
  "wY": "PiPOverlay.module__footerGradient___NEE1MD",
  "z8": "PiPOverlay.module__footerContent___NEE1MD",
  "PU": "PiPOverlay.module__footerLeft___NEE1MD",
  "zz": "PiPOverlay.module__streamerName___NEE1MD",
  "wV": "PiPOverlay.module__footerRight___NEE1MD",
  "ti": "PiPOverlay.module__spectatorBadge___NEE1MD",
  "Bh": "PiPOverlay.module__spectatorIcon___NEE1MD",
  "hP": "PiPOverlay.module__actionButton___NEE1MD",
  "P4": "PiPOverlay.module__disconnectButton___NEE1MD",
  "gE": "PiPOverlay.module__actionIcon___NEE1MD",
};

module.exports = exports;
